// extracted by mini-css-extract-plugin
export default {"page":"JobboardProfileOnboarding_page__jcUv5","main":"JobboardProfileOnboarding_main__O9CAR","loading":"JobboardProfileOnboarding_loading__PRg0X"};